import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TimelineService} from "../../services/timeline/timeline.service";
import {LabelType, Options} from '@angular-slider/ngx-slider';

@Component({
  selector: 'timeline-slider',
  templateUrl: './timeline-slider.component.html',
  styleUrls: ['./timeline-slider.component.scss']
})
export class TimelineSliderComponent implements OnInit {

  public isSliderVisible = false;
  public isListVisibility = false;
  public latestValue = null;
  public defaultTimeValue = null;
  public sliderOptions: Options = {
    showTicks: true,
    translate: (value: number, label): string => {
      let d = new Date();
      d.setTime(value);
      let h = d.getHours();
      let m = d.getMinutes();
      let date = d.getDate();
      let month = d.getMonth() + 1;

      let r = h + ':' + (m < 10 ? ('0' + m) : m) + ' / ' + date + '.' + (month ? ('0' + month) : month);

      if (this.activeFrames.length > 0 && (label !== LabelType.Floor && label !== LabelType.Ceil)) {
        r+= '<br/>(' + this.activeFrames + ')';
      }
      return r;
    }
  };
  public activeFrames: string = '';
  private defaultTimestamp = null;

  constructor(
    private timelineService: TimelineService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    //this.sliderOptions.floor = this.getMinSliderValue();
    //this.sliderOptions.ceil = this.getMaxSliderValue();
    this.timelineService.timeline_slider = this;
    let r = [];
    for (let i = this.getMinSliderValue(); i <= this.getMaxSliderValue(); i+= 3600000) {
      let d = new Date();
      d.setTime(i);
      r.push({value: i });
    }
    this.sliderOptions.stepsArray = r;

    this.timelineService.activeFrames.subscribe(frames => {
      this.activeFrames = frames.join(', ');
      this.cdr.markForCheck();
    });

    this.setTime(null);
    if(!this.defaultTimeValue){
      this.defaultTimeValue = this.latestValue ? this.latestValue : this.getMinSliderValue();
    }
  }

  setSliderInterval(timelineConfig?){
    this.defaultTimestamp = new Date(this.timelineService.defaultTimeString).getTime();
    let r = [];
    if(timelineConfig){
      let timestampMs = 3600000 * 24;
      if (timelineConfig.info && typeof timelineConfig.info == 'string'){
        try {
          timelineConfig.info = JSON.parse(timelineConfig.info);
        }
        catch (e){
          console.error('can\'t parse json info');
        }
      }
      if (timelineConfig.hasOwnProperty('info') && timelineConfig.info && timelineConfig.info.hasOwnProperty('generic_config') && timelineConfig.info.generic_config.hasOwnProperty('granularity')){
        let granularity = timelineConfig.info.generic_config.granularity;
        if (granularity.stepMs){
          timestampMs = granularity.stepMs;
        }
        else if (granularity.step){
          timestampMs = this.getMsFromString(granularity.step);
        }
        this.timelineService.selectedTimelineGranularity = timestampMs;
      }

      // if (timestampMs > this.getMaxSliderValue()){
      //   timestampMs = this.getMaxSliderValue();
      // }


      const minTime = this.getMinSliderValue();
      const maxTime = this.getMaxSliderValue();
      for (let i = minTime; i < maxTime; i+= timestampMs) {
        let d = new Date();
        d.setTime(i);
        r.push({value: i });
      }
      r.push({value: maxTime });
    }
    else{
      for (let i = this.getMinSliderValue(); i <= this.getMaxSliderValue(); i+= 3600000 * 24) {
        let d = new Date();
        d.setTime(i);
        r.push({value: i });
      }
      const maxTime = this.getMaxSliderValue();
      if (r[r.length-1] != maxTime){
        r.push({value: maxTime });
      }
    }
    let tmpOptions:Options = Object.assign({}, this.sliderOptions);
    tmpOptions.stepsArray = r;
    this.sliderOptions = tmpOptions;
    if (this.isSliderVisible) {
      this.setTime(this.sliderOptions.stepsArray[0].value);
    } else {
      this.latestValue = this.sliderOptions.stepsArray[0].value;
    }
    this.cdr.detectChanges();
  }

  getMsFromString(str){
    var mSeconds = 0;
    var days = str.match(/(\d+)\s*d/);
    var hours = str.match(/(\d+)\s*h/);
    var minutes = str.match(/(\d+)\s*m/);
    if (days) { mSeconds += parseInt(days[1])*86400*1000; }
    if (hours) { mSeconds += parseInt(hours[1])*3600*1000; }
    if (minutes) { mSeconds += parseInt(minutes[1])*60*1000; }
    return mSeconds;
  }

  toggleSlider() {
    this.isSliderVisible = !this.isSliderVisible;
    if (!this.isSliderVisible) {
      this.setTime(null);
    } else {
      this.setTime(this.latestValue ? this.latestValue : this.getMinSliderValue());
    }
  }

  toggleListVisibility(){
    this.isListVisibility = !this.isListVisibility;
  }

  getMinSliderValue() {
    return this.timelineService.getMinDate();
  }

  getMaxSliderValue() {
    return this.timelineService.getMaxDate();
  }

  setTime($event) {
    // if (this.isSliderVisible) {
      this.timelineService.setTime($event);
    // }
  }

}
